(function () {
  var SKIP = /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|NOSCRIPT|CODE|PRE|SVG|TITLE)$/;

  function wrapTextNode(node) {
    var text = node.nodeValue;
    if (!text || text.indexOf('®') === -1) return;
    var parts = text.split('®');
    if (parts.length < 2) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < parts.length; i++) {
      if (parts[i]) frag.appendChild(document.createTextNode(parts[i]));
      if (i < parts.length - 1) {
        var sup = document.createElement('sup');
        sup.className = 'ge-reg';
        sup.textContent = '®';
        frag.appendChild(sup);
      }
    }
    node.parentNode.replaceChild(frag, node);
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      wrapTextNode(root);
      return;
    }
    if (root.nodeType !== 1) return;
    if (SKIP.test(root.tagName)) return;
    if (root.classList && root.classList.contains('ge-reg')) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var parent = n.parentElement;
        if (!parent || SKIP.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (parent.closest && parent.closest('sup.ge-reg, .ge-reg')) return NodeFilter.FILTER_REJECT;
        if (!n.nodeValue || n.nodeValue.indexOf('®') === -1) return NodeFilter.FILTER_SKIP;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) wrapTextNode(nodes[i]);
  }

  function run() {
    walk(document.body);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
